import { db } from '../database/firebase';
import { collection, getDocs, query, orderBy, limit } from 'firebase/firestore';
import { apiGet, useApiData } from './apiClient';

const matchesSearch = (user, search) => {
  const s = search.toLowerCase();
  return (
    String(user.email || '')
      .toLowerCase()
      .includes(s) ||
    String(user.name || '')
      .toLowerCase()
      .includes(s) ||
    String(user.surname || '')
      .toLowerCase()
      .includes(s) ||
    String(user.mobile || '').includes(search)
  );
};

const looksLikeEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

/**
 * @returns {Promise<{ data: Array, total: number }>}
 */
export const getUsers = async ({ search, emailFilter, phoneFilter, last = 100 } = {}) => {
  const searchText = (search || emailFilter || phoneFilter || '').trim();

  if (useApiData) {
    const qs = new URLSearchParams();
    qs.set('page', '1');
    if (searchText) {
      qs.set('q', searchText);
      if (looksLikeEmail(searchText)) {
        qs.set('email', searchText.toLowerCase());
      }
      // Sunucu taraflı arama — tüm kullanıcılar (sayfa içi değil)
      qs.set('perPage', String(Math.min(Math.max(last, 200), 500)));
    } else {
      qs.set('perPage', String(last));
    }
    const res = await apiGet(`users?${qs.toString()}`);
    return {
      data: res?.data ?? [],
      total: typeof res?.total === 'number' ? res.total : (res?.data?.length ?? 0),
    };
  }

  const collectionRef = collection(db, 'users');
  const q = query(collectionRef, orderBy('createDateTime', 'desc'), limit(last));
  const snap = await getDocs(q);
  const rows = [];
  snap?.forEach((docRef) => rows.push({ id: docRef.id, ...docRef.data() }));

  if (!searchText) return { data: rows, total: rows.length };
  const filtered = rows.filter((user) => matchesSearch(user, searchText));
  return { data: filtered, total: filtered.length };
};

export default { getUsers };
